import { Container, LoaderShell, LoaderRing, LoaderCore, BrandMark } from './styled'
import { P } from '../Text'
import { useTranslation } from 'react-i18next'

interface LoaderProps {
  text?: string
  style?: React.CSSProperties
  fontWeight?: number
  margin?: string
  fontSize?: string
}

const Loader = ({ text, style, fontWeight, margin, fontSize }: LoaderProps) => {
  const { t } = useTranslation()
  return (
    <Container style={style}>
      <LoaderShell aria-label="loader bluesite" role="status">
        <LoaderRing />
        <LoaderCore>
          <BrandMark>B.</BrandMark>
        </LoaderCore>
      </LoaderShell>
      <P fontSize={fontSize || '15px'} fontWeight={fontWeight || 700} color="#245D7D" margin={margin || '0px'}>
        {text ? text : t('global.common.loadingText')}
      </P>
    </Container>
  )
}

export default Loader
